/* eslint-disable */
// @ts-nocheck

import moment from 'moment'

import { DocumentProps, PageProps, Style } from '@react-pdf/types'

import {
  BusinessInterface,
  OrderInterface,
} from '../interfaces/ServerInterfaces'
import { formatCurrency } from '../utils/helpers'
import { translateOrderState } from '../utils/translate'
import Report from './components/Report'

interface OrderListReportProps {
  reportName: string
  businessData: BusinessInterface
  reportData: OrderInterface[]
  reportSettings?: {
    document?: DocumentProps
    page?: PageProps
  }
}

const OrderListReport = ({
  reportName,
  businessData,
  reportData,
  reportSettings,
}: OrderListReportProps) => {
  const rows: any[] = []
  const valueRowStyle: Record<number, Style> = {}

  reportData.forEach((order) => {
    const orderRow: (string | number)[] = []
    if (order.operationNumber) {
      orderRow.push(order.operationNumber + '~subtitle')
    }
    if (order.createdAt) {
      orderRow.push(
        moment(order.createdAt).format('DD [de] MMMM [de] YYYY') + '~subtitle'
      )
    }
    if (order.totalToPay) {
      orderRow.push(
        order.totalToPay
          .map((pay) => formatCurrency(pay.amount, pay.codeCurrency))
          .join('\n') + '~subtitle'
      )
    }
    if (order.status) {
      orderRow.push(translateOrderState(order.status) + '~subtitle')
    }
    if (order.paidAt) {
      orderRow.push(
        moment(order.paidAt).format('DD [de] MMMM [de] YYYY') + '~subtitle'
      )
    } else {
      orderRow.push('-~subtitle')
    }
    rows.push(orderRow)

    if (order?.selledProducts?.length) {
      valueRowStyle[rows.length - 1] = { borderBottom: 0 }

      rows.push([
        'Listado de productos~subtitle',
        'Cantidad~subtitle',
        '',
        '',
        '',
      ])
      valueRowStyle[rows.length - 1] = { borderBottom: 0 }

      order?.selledProducts?.forEach((product, index) => {
        rows.push([
          `   - ${product.name}${
            product.variation ? ' (' + product.variation.name + ')' : ''
          }`,
          product.quantity,
          '',
          '',
          '',
        ])
        if (index < order?.selledProducts?.length - 1)
          valueRowStyle[rows.length - 1] = { borderBottom: 0 }
      })
      ///rows.push(...productRows);
    }
  })

  const data: any[] = [
    `${reportName}~title`,
    'titleSeparator',
    {
      display: 'table',
      widths: [15, 15, 15, 15],
      headers: ['No', 'Fecha', 'Total', 'Estado', 'Pagado el'],
      valueRowStyle,
      values: rows,
      valuesStyles: [],
    },
  ]

  return (
    <Report
      headerData={businessData}
      reportData={data}
      reportName={reportName}
      reportSettings={reportSettings}
    />
  )
}

export default OrderListReport
